import { Injectable } from '@angular/core';
import { SalaryStructure } from '../model';
import { BaseService } from '../../shared/baseService';

@Injectable({
    providedIn: 'root'
})

export class SalaryStructuresService extends BaseService<SalaryStructure> {
    constructor() {
        super('SalaryStructure');
    }
}
